const Footer = (props) => {
    return (
        <div className="footer">
            <h6>&copy; All rights reserved</h6>
        </div>
    )
}
export default Footer